import { z } from "zod";

export const siteAlertDtoSchema = z.object({
  refSiteAlertId: z.number(),
  note: z.string(),
});

export type TSiteAlertDto = z.infer<typeof siteAlertDtoSchema>;
